import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { PaginationComponent } from '../pagination/pagination.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PaginatedDbClients } from 'shared/services/clients.service';
import { PaginatedDbProducts, ProductsService } from 'shared/services/products.service';
import { DataSynchronizerService } from 'shared/services/data-synchronization.service';
import { debounce } from 'lodash-es';
import { VatRateUtils } from 'fakturnia-shared';

@Component({
  selector: 'products-table',
  standalone: true,
  imports: [CommonModule, RouterLink, MatTooltipModule, MatCheckboxModule, MatButtonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatIconModule, MatProgressSpinnerModule, PaginationComponent],
  templateUrl: './products-table.component.html',
  styleUrl: './products-table.component.scss'
})
export class ProductsTableComponent implements OnInit, OnDestroy  {

  private _subscriptions: Subscription[] = [];

  activeFilters = new Set<any>();
  bsActiveFilters = new BehaviorSubject<any>(this.activeFilters);
  currentActiveFilters = this.bsActiveFilters.asObservable();
  
  searchControl = new FormControl('', { nonNullable: true })

  pagination:PaginatedDbProducts = {
    pageSize: 10,
    pages: 0,
    currentPage: 1,
    results: null,
    resultsCount: 0,
    executionTime: 0
  }

  @Input() showTitle = true
  @Input() showAddNewButton = true
  @Input() title = 'Baza produktów'
  @Input('filters') filters:any[] = []
  
  constructor(
    private _productsService: ProductsService,
    private _dataSynchronizerService: DataSynchronizerService
    ) {

    this._browse = debounce(this._browse,10)
  }

  public reset() {
    this.searchControl.setValue('')
    this.search('')
  }
  
  public search(value)
  {
    this.pagination.currentPage = 1;
    this._updateFilterSet('searchText',value)
    this._browse();
  }

  public onPageChange(page)
  {
    this.pagination.currentPage = page;
    this._browse();
  }

  private _browse() {
    this.pagination = this._productsService.browseProducts({
      currentPage: this.pagination.currentPage,
      pageSize: this.pagination.pageSize,
      filters: this.filters,
      activeFilters: this.activeFilters,
    })
  }

  private _updateFilterSet(key, value) {
    if (!value || value == '') {
      // Jeśli wartość jest pustym ciągiem lub białym znakiem, usuń filtr z zestawu
      for (let filter of this.activeFilters) {
        if (filter[0] === key) {
          this.activeFilters.delete(filter);
          // this.searchResults = Object.entries(this.databaseService.data.value.documents).filter((document:[any,DbDocument])=> !document[1].isDeleted).map(x=>x[1]);
          this.bsActiveFilters.next(this.activeFilters)
          return;
        }
      }
      return;
    }
    // Sprawdzenie, czy dany klucz już istnieje w secie
    for (let filter of this.activeFilters) {
      if (filter[0] === key) {
        // Jeśli klucz istnieje, zaktualizuj wartość filtra
        // Jezeli nowa wartość filtra jest inna od obecnego
        if(filter[1] != value) {
          // Jezeli jest stringiem
          if(typeof filter[1] == 'string')
          {
            // Zwieksz zakres tylko jezeli wartosc jest mniejsza
            //sprawdz czy jest mniejsza (zwieksz zakres)
            if(filter[1].length > value.length)
            {
              // this.searchResults = Object.entries(this.databaseService.data.value.documents).filter((document:[any,DbDocument])=> !document[1].isDeleted).map(x=>x[1]);
            }

            filter[1] = value;
          }
          // Jezeli jest pozostałym typem
          else {
            filter[1] = value;
            // this.searchResults = Object.entries(this.databaseService.data.value.documents).filter((document:[any,DbDocument])=> !document[1].isDeleted).map(x=>x[1]);
          }
        } 

        
        this.bsActiveFilters.next(this.activeFilters)
        return;
      }
    }
    // Jeśli klucz nie istnieje, dodaj nowy filtr
    this.activeFilters.add([key, value]);
    this.bsActiveFilters.next(this.activeFilters)
  }

  ngOnInit(): void {

    this._subscriptions.push(
      this.searchControl.valueChanges.subscribe({
        next: (value) => {
          this.search(value)
        }
      })
    )

    this._subscriptions.push(this._dataSynchronizerService.currentData.subscribe({
      next: (data)=>{
        if(data == null) return
        if(data.table == 'products') this._browse()
      }
    }))

    this._subscriptions.push(this.currentActiveFilters.subscribe({
      next:  (data)=>
        {
          this.activeFilters = data;
          setTimeout( async ()=>{
            this._browse();
          })
        }
      }
    ))

    this._browse();
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub=>sub.unsubscribe())
  }

  public isNumberVatRate(vatRate: any): boolean {
    return VatRateUtils.isNumberVatRate(vatRate);
  }

  public getVatRateDisplay(vatRate: any): string {
    return VatRateUtils.getDisplayValue(vatRate);
  }
}
